module.exports = __webpack_public_path__ + "img/t1-feature-text.a170fb93.png";